export const EnvConfiguration = WEBPACK_GLOBAL;
